import type { AircraftDoc } from './types';

export interface BillingBreakdown {
  hoursFlown: number;
  baseCharge: number;
  awayFromBaseCharge: number;
  totalCharge: number;
  awayNights: number;
}

export function computeFlightCharge(args: {
  aircraft: AircraftDoc;
  hobbsOut: number;
  hobbsIn: number;
  awayNights: number;
}): BillingBreakdown {
  const hoursFlown = Math.max(0, +(args.hobbsIn - args.hobbsOut).toFixed(1));
  const baseCharge = +(hoursFlown * args.aircraft.hourlyRate).toFixed(2);

  // Lease §5.3 is a FLOOR, not an add-on (changed 2026-08-28 to match how clubs,
  // schools and FBOs universally write this). Hours actually flown count toward the
  // nightly minimum; only the SHORTFALL is billed. A 3-night trip with 4.0 hrs flown
  // owes 6 hrs total — not 4 + 6.
  const minimumHours = +(args.awayNights * args.aircraft.awayFromBaseHoursPerDay).toFixed(1);
  const shortfallHours = Math.max(0, +(minimumHours - hoursFlown).toFixed(1));
  const awayFromBaseCharge = +(shortfallHours * args.aircraft.hourlyRate).toFixed(2);
  return {
    hoursFlown,
    baseCharge,
    awayFromBaseCharge,
    totalCharge: +(baseCharge + awayFromBaseCharge).toFixed(2),
    awayNights: args.awayNights,
  };
}
